module.exports = __webpack_public_path__ + "media/images/advisor/img_4_0-372c2c29c10a8c75bcac03e5d4596f83.png";